module.exports = __webpack_public_path__ + "img/changeDevieIcon.51e4f5f0.png";